import BaseCollection from '../../base/BaseCollection'
import { bindAll2, addClass, removeClass } from '../../domUtil'

export default class BaseMarkerLayer extends BaseCollection {
    constructor(map) {
        super()

        this._selectIndex = -1
        this._map = map
    }

    // 选中索引
    set SelectIndex(value) {
        const pre = this.query(this._selectIndex)
        if (pre.length) {
            BaseMarkerLayer.ToggleSelect(pre[0].getElement(), false)
            this._selectIndex = -1
        }
        const next = this.query(value)
        if (next.length) {
            BaseMarkerLayer.ToggleSelect(next[0].getElement(), true)
            this._selectIndex = value
        }
    }
    get SelectIndex() {
        return this._selectIndex
    }

    add(marker) {
        super.add(marker)
        this._addMarkers2Map([marker])
    }

    remove(v) {
        const markers = super.remove(v)
        markers.forEach(m => m.remove())
    }

    /**
     * addAll
     * @param {Array} markers
     */
    addAll(markers) {
        super.addAll(...markers)
        this._addMarkers2Map(markers)
    }

    clear() {
        this.forEach(m => m.remove())
        super.clear()
    }

    /**
     * @private
     * @param {Array} markers
     */
    _addMarkers2Map(markers) {
        markers.forEach(m => {
            // add to map
            m.addTo(this._map)

            // 兼容popup
            if (m instanceof mapboxgl.Popup) return

            // marker继续
            const ele = m.getElement()
            // bind events
            bindAll2(ele, [
                [
                    ['mouseenter', 'mouseleave', 'click'],
                    evt => {
                        const { type, target } = evt
                        const i = this.findIndex(m)
                        if (type === 'mouseenter') {
                            this.fire('select', m, i)
                            addClass(target, 'select')
                        }
                        if (type === 'mouseleave') {
                            this.fire('unselect', m, i)
                            removeClass(target, 'select')
                        }
                        if (type === 'click') {
                            this.fire('click', m, i)
                        }
                    }
                ]
            ])
        })
    }

    /**
     * 切换图片
     * @param {HTMLDivElement} target
     * @param {Boolean} selected
     */
    static ToggleSelect(target, selected) {
        selected ? addClass(target, 'select') : removeClass(target, 'select')
    }
}
